/**
 * 券中心
 */
export default [
  {
    path: '/coupon',
    component: () => import(/* webpackChunkName: "Coupon" */ '@/views/coupon/Index.vue'),
    meta: { requiresAuth: true, title: '券中心', icon: 'el-icon-s-ticket' },
    children:
      [
        {
          path: '/',
          redirect: 'list',
        },
        {
          path: 'add',
          component: () => import(/* webpackChunkName: "Coupon" */ '@/views/coupon/CouponCreatFirstStep.vue'),
          meta: { title: '创建优惠券' },
        },
        {
          path: 'copy/:id',
          component: () => import(/* webpackChunkName: "Coupon" */ '@/views/coupon/CouponCreatFirstStep.vue'),
          meta: { title: '复制优惠券', copy: true },
        },
        {
          path: 'list',
          component: () => import(/* webpackChunkName: "Coupon" */ '@/views/coupon/List.vue'),
          meta: { title: '券库管理', role: true },
        },
        {
          path: 'detail/:id',
          component: () => import(/* webpackChunkName: "Coupon" */ '@/views/coupon/Detail.vue'),
          meta: { title: '券详情' },
        },
        // {
        // 	path: 'copy/:id',
        // 	component: () => import(/* webpackChunkName: "Coupon" */ '@/views/CouponAdd.vue'),
        // 	meta: { title: '复制优惠券', copy: true },
        // },
        // {
        // 	path: 'verify',
        // 	component: () => import(/* webpackChunkName: "Coupon" */ '@/views/CouponVerify.vue'),
        // 	meta: { title: '领取与核销管理', role: true },
        // },
        {
          path: 'audit',
          component: () => import(/* webpackChunkName: "Coupon" */ '@/views/coupon/Audit.vue'),
          meta: { title: '券审核' },
          children: [
            {
              path: '',
              redirect: 'list',
            },
            {
              path: 'list',
              component: () => import(/* webpackChunkName: "Coupon" */ '@/views/coupon/AuditCouponList.vue'),
              meta: { title: '券审核列表' },
            },
            {
              path: 'details',
              component: () => import(/* webpackChunkName: "Coupon" */ '@/views/coupon/AuditCouponDetail.vue'),
              meta: { title: '券审核详情' },
            }
          ]
        },
        {
          path: 'injection',
          component: () => import(/* webpackChunkName: "Coupon" */ '@/views/coupon/ActivityList.vue'),
          meta: { title: '券投放', role: true },
        },
      ],
  },
];
